"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zeroPad = exports.reverseDateFormat = exports.isSameMonth = exports.isSameDay = exports.isDate = exports.getPreviousMonth = exports.getNextMonth = exports.getMonthFirstWeekday = exports.getMonthDays = exports.getDateISO = exports.default = exports.WEEK_DAYS = exports.THIS_YEAR = exports.THIS_MONTH = exports.CALENDAR_WEEKS = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// (int) The current year
var THIS_YEAR = +new Date().getFullYear();

// (int) The current month starting from 1 - 12
// 1 => January, 12 => December
exports.THIS_YEAR = THIS_YEAR;
var THIS_MONTH = +new Date().getMonth() + 1;

// Week days names and shortnames
exports.THIS_MONTH = THIS_MONTH;
var WEEK_DAYS = /*#__PURE__*/function (WEEK_DAYS) {
  WEEK_DAYS["MONDAY"] = "Monday";
  WEEK_DAYS["TUESDAY"] = "Tuesday";
  WEEK_DAYS["WEDNESDAY"] = "Wednesday";
  WEEK_DAYS["THRUSDAY"] = "Thursday";
  WEEK_DAYS["FRIDAY"] = "Friday";
  WEEK_DAYS["SATURDAY"] = "Saturday";
  WEEK_DAYS["SUNDAY"] = "Sunday";
  return WEEK_DAYS;
}({}); // Weeks displayed on calendar
exports.WEEK_DAYS = WEEK_DAYS;
var CALENDAR_WEEKS = 6;

// Pads a string value with leading zeroes(0) until length is reached
// For example: zeroPad(5, 2) => "05"
exports.CALENDAR_WEEKS = CALENDAR_WEEKS;
var zeroPad = function zeroPad(value, length) {
  return "".concat(value).padStart(length, '0');
};

// (int) Number days in a month for a given year from 28 - 31
exports.zeroPad = zeroPad;
var getMonthDays = function getMonthDays() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THIS_YEAR;
  var months30 = [4, 6, 9, 11];
  var leapYear = year % 4 === 0;
  return month === 2 ? leapYear ? 29 : 28 : months30.includes(month) ? 30 : 31;
};

// (int) Number representation (1-7) of the first weekday in the month for a given year
// 1 => Monday, 7 => Sunday
exports.getMonthDays = getMonthDays;
var getMonthFirstWeekday = function getMonthFirstWeekday() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THIS_YEAR;
  var date = new Date("".concat(year, "-").concat(zeroPad(month, 2), "-01"));

  // getDate is naturally Sun-Sat on 0-6 scale so we modulo it to be Mon-Sun then +1
  return (date.getDay() + 6) % 7 + 1;
};

// (bool) Checks if a value is a date - this is just a simple check
exports.getMonthFirstWeekday = getMonthFirstWeekday;
var isDate = function isDate(date) {
  var isDate = Object.prototype.toString.call(date) === '[object Date]';
  var isValidDate = date && !Number.isNaN(date.valueOf());
  return isDate && isValidDate;
};

// (bool) Checks if two date values are of the same month and year
exports.isDate = isDate;
var isSameMonth = function isSameMonth(date) {
  var basedate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!(isDate(date) && isDate(basedate))) return false;
  var basedateMonth = +basedate.getMonth() + 1;
  var basedateYear = basedate.getFullYear();
  var dateMonth = +date.getMonth() + 1;
  var dateYear = date.getFullYear();
  return +basedateMonth === +dateMonth && +basedateYear === +dateYear;
};

// (bool) Checks if two date values are the same day
exports.isSameMonth = isSameMonth;
var isSameDay = function isSameDay(date) {
  var basedate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!(isDate(date) && isDate(basedate))) return false;
  var basedateDate = basedate.getDate();
  var basedateMonth = +basedate.getMonth() + 1;
  var basedateYear = basedate.getFullYear();
  var dateDate = date.getDate();
  var dateMonth = +date.getMonth() + 1;
  var dateYear = date.getFullYear();
  return +basedateDate === +dateDate && +basedateMonth === +dateMonth && +basedateYear === +dateYear;
};

// (string) Converts the format of a YYYY-MM-DD string to DD-MM-YYYY or vice versa
exports.isSameDay = isSameDay;
var reverseDateFormat = function reverseDateFormat() {
  var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!dateString) return '';
  return dateString.split("-").reverse().join("-");
};

// (string) Formats the given date as YYYY-MM-DD
// Months and Days are zero padded
exports.reverseDateFormat = reverseDateFormat;
var getDateISO = function getDateISO() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  if (!isDate(date)) return null;
  return [date.getFullYear(), zeroPad(+date.getMonth() + 1, 2), zeroPad(+date.getDate(), 2)].join('-');
};

// ({month, year}) Gets the month and year before the given month and year
// For example: getPreviousMonth(1, 2000) => {month: 12, year: 1999}
// while: getPreviousMonth(12, 2000) => {month: 11, year: 2000}
exports.getDateISO = getDateISO;
var getPreviousMonth = function getPreviousMonth(month, year) {
  var prevMonth = month > 1 ? month - 1 : 12;
  var prevMonthYear = month > 1 ? year : year - 1;
  return {
    month: prevMonth,
    year: prevMonthYear
  };
};

// ({month, year}) Gets the month and year after the given month and year
// For example: getNextMonth(1, 2000) => {month: 2, year: 2000}
// while: getNextMonth(12, 2000) => {month: 1, year: 2001}
exports.getPreviousMonth = getPreviousMonth;
var getNextMonth = function getNextMonth(month, year) {
  var nextMonth = month < 12 ? month + 1 : 1;
  var nextMonthYear = month < 12 ? year : year + 1;
  return {
    month: nextMonth,
    year: nextMonthYear
  };
};

// Calendar builder for a month in the specified year
// Returns an array of the calendar dates.
// Each calendar date is represented as an array => [YYYY, MM, DD]
exports.getNextMonth = getNextMonth;
var _default = function _default() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THIS_YEAR;
  // Get number of days in the month and the month's first day
  var monthDays = getMonthDays(month, year);
  var monthFirstWeekday = getMonthFirstWeekday(month, year);

  // Get number of days to be displayed from previous and next months
  // These ensure a total of 42 days (6 weeks) displayed on the calendar
  var daysFromPrevMonth = monthFirstWeekday - 1;
  var daysFromNextMonth = CALENDAR_WEEKS * 7 - (daysFromPrevMonth + monthDays);

  // Get the previous and next months and years
  var _getPreviousMonth = getPreviousMonth(month, year),
    prevMonth = _getPreviousMonth.month,
    prevMonthYear = _getPreviousMonth.year;
  var _getNextMonth = getNextMonth(month, year),
    nextMonth = _getNextMonth.month,
    nextMonthYear = _getNextMonth.year;

  // Get number of days in previous month
  var prevMonthDays = getMonthDays(prevMonth, prevMonthYear);

  // Builds dates to be displayed from previous month
  var prevMonthDates = _toConsumableArray(new Array(daysFromPrevMonth)).map(function (n, index) {
    var day = index + 1 + (prevMonthDays - daysFromPrevMonth);
    return [prevMonthYear, zeroPad(prevMonth, 2), zeroPad(day, 2)];
  });

  // Builds dates to be displayed from current month
  var thisMonthDates = _toConsumableArray(new Array(monthDays)).map(function (n, index) {
    var day = index + 1;
    return [year, zeroPad(month, 2), zeroPad(day, 2)];
  });

  // Builds dates to be displayed from next month
  var nextMonthDates = _toConsumableArray(new Array(daysFromNextMonth)).map(function (n, index) {
    var day = index + 1;
    return [nextMonthYear, zeroPad(nextMonth, 2), zeroPad(day, 2)];
  });

  // Combines all dates from previous, current and next months
  return [].concat(_toConsumableArray(prevMonthDates), _toConsumableArray(thisMonthDates), _toConsumableArray(nextMonthDates));
};
exports.default = _default;